var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:( _obj = {}, _obj[_vm.css.iconButton] = true, _obj[_vm.css[_vm.theme]] = true, _obj[_vm.css.isActive] = _vm.isActive, _obj[_vm.css.isDisabled] = _vm.isDisabled, _obj ),style:({
    '--size': _vm.ICON_BUTTON_SIZE_MAP[_vm.size]
  }),attrs:{"disabled":_vm.isDisabled,"to":_vm.to,"type":_vm.tag === 'button' ? 'button' : null}},[_vm._t("default"),_vm._v(" "),_c('SvgIcon',{directives:[{name:"show",rawName:"v-show",value:(_vm.iconVisible),expression:"iconVisible"}],key:_vm.name,attrs:{"name":_vm.name}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }